/**
 * +capture: the renderer's slot for the trailer camera (debug/capture.ts fills it under ?capture=1;
 * null otherwise, so normal play never takes this path). Kept dependency-free so the renderer can
 * import it without pulling the capture tooling into its graph.
 */
import type * as THREE from 'three';
import type { CameraRig } from '../render/camera';

/** The renderer's lights and grade, for the capture-only lighting presets. */
export interface CaptureLights {
  key: THREE.DirectionalLight;
  hemi: THREE.HemisphereLight;
  grade: { uSat: THREE.IUniform<number>; uGain: THREE.IUniform<THREE.Vector3>; uLift: THREE.IUniform<THREE.Vector3> };
  /** Sun direction (the key sits along it from the focus). */
  keyDir: THREE.Vector3;
}

export interface CaptureHook {
  /** Place `camera` after the rig did (sim coords → three.js); returns the FOV it set. */
  camera: ((camera: THREE.PerspectiveCamera, rig: CameraRig, groundY: (x: number, y: number) => number, scene: THREE.Scene, lights: CaptureLights) => number) | null;
}

export const captureHook: CaptureHook = { camera: null };
